import React from 'react';
import CoverageDemo from './CoverageDemo';
import CoverageSetup from './CoverageSetup';

export default function CoveragePublicApp() {
  const [, , surface, id] = window.location.pathname.split('/');
  return surface === 'setup' ? (
    <CoverageSetup slug={id} />
  ) : (
    <CoverageDemo demoId={id} />
  );
}
